"use strict";

var _interopRequireDefault = require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _appCitysData = _interopRequireDefault(require("@/assets/static/js/citys/app.citys.data.js"));
var _api = require("../api/api");
var _default = exports.default = {
  name: 'join_form',
  props: {
    businessType: {
      type: String,
      require: true,
      default: ''
    },
    titleTxt: {
      type: String,
      require: true,
      default: ''
    },
    subTitleTxt: {
      type: String,
      default: ''
    },
    subTitleColor: {
      type: String,
      default: '#333'
    },
    submitBtnTxt: {
      type: String,
      default: '确认提交'
    },
    hasPhoneFooter: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      unSupportCitysArr: ['台湾', '香港特别行政区', '澳门特别行政区', '钓鱼岛'],
      city: [],
      citys: _appCitysData.default.cityDataWithoutDistrict,
      //出发城市数据
      cityId: 0,
      jForm: {
        businessName: '',
        businessCellphone: '',
        businessCompany: '',
        businessCity: '',
        businessCityId: 0,
        businessType: this.businessType,
        // 商业合作类型(10:招投标,20:WMS,30:TMS)
        generalizeUserId: '',
        //推广人id
        generalizeSource: '10' //来源,PC:10,wap:20
      },
      jRules: {
        businessName: [{
          required: true,
          message: '请填写您的姓名',
          trigger: 'blur'
        }],
        businessCellphone: [{
          required: true,
          message: '请输入您的手机号码',
          trigger: 'blur'
        }, {
          pattern: /^1\d{10}$/,
          message: '请输入正确的手机号',
          trigger: 'blur'
        }],
        businessCompany: [{
          required: true,
          message: '请输入您的公司名称',
          trigger: 'blur'
        }],
        businessCity: [{
          required: true,
          message: '请选择所在城市',
          trigger: 'change'
        }]
      }
    };
  },
  created: function created() {
    // guid 推广人id
    this.jForm.generalizeUserId = this.$route.query.guid ? typeof this.$route.query.guid == 'string' ? this.$route.query.guid : this.$route.query.guid[0] : '';
  },
  methods: {
    //选择到达城市
    cityChange: function cityChange(value) {
      var that = this;
      if (value.length > 0 && this.unSupportCitysArr.includes(value[0])) {
        value = [];
        that.city = [];
        that.cityId = 0;
        that.jForm.businessCity = '';
        that.jForm.businessCityId = 0;
        that.$message({
          message: '该地区业务还未开展',
          type: 'warning'
        });
        return;
      } else if (value.length > 0 && !this.unSupportCitysArr.includes(value[0])) {
        that.jForm.businessCity = value.join('/').replace(/\/全省/g, '').replace(/\/全市/g, '');
        that.city = value;
        that.getCityId(this.citys, value, 0);
      }
    },
    // 获取城市id
    getCityId: function getCityId(citys, arr, n) {
      var _this = this;
      citys.filter(function (item) {
        if (item.label == arr[n]) {
          if (item.children) {
            n++;
            return _this.getCityId(item.children, arr, n);
          } else {
            _this.jForm.businessCityId = item.value;
            _this.cityId = item.value;
          }
        }
      });
    },
    // 表单提交
    jFormSubmit: function jFormSubmit(formName) {
      var _this2 = this;
      this.$refs[formName].validate(function (valid) {
        console.log(valid);
        if (valid) {
          _this2.jForm.businessCity = _this2.jForm.businessCity.replace(/\/全省/g, '');
          _this2.jForm.businessCity = _this2.jForm.businessCity.replace(/\/全市/g, '');
          var jsonParam = {
            jsonParam: JSON.stringify(_this2.jForm)
          };
          var paramStr = {
            version: '1',
            fun: 'savebusinesscooperation',
            param: jsonParam
          };
          var reqParam = {
            jsonParamete: JSON.stringify(paramStr)
          };
          _this2.saveBusinessCooperation(reqParam);
        } else {
          _this2.$message({
            message: '请正确填写信息!',
            type: 'error',
            duration: '5000'
          });
          return false;
        }
      });
    },
    // 表单保存请求
    saveBusinessCooperation: function () {
      var _saveBusinessCooperation = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(param) {
        var that, _yield$apiGetBusiness, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              that = this;
              _context.next = 3;
              return (0, _api.apiGetBusinessCooperation)(param);
            case 3:
              _yield$apiGetBusiness = _context.sent;
              data = _yield$apiGetBusiness.data;
              if (data.proCode == '200') {
                this.$message({
                  message: '提交成功!',
                  type: 'success',
                  duration: '5000'
                });
                // 初始化全部的 data数据
                Object.assign(this.$data, this.$options.data());
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function saveBusinessCooperation(_x) {
        return _saveBusinessCooperation.apply(this, arguments);
      }
      return saveBusinessCooperation;
    }()
  }
};